import * as React from 'react';
import { ChangeEvent } from 'react';

import './Input.css';

interface Props {
  id: string;
  value?: string | File;
  label: string;
  placeholder?: string;
  type: string;
  required: boolean;
  autocomplete: boolean;
  maxLength?: number;
  iconName?: string;
  disabled: boolean;
  onBlur?(): void;
  onChange(value: string | File): void;
}

class InputComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {
    let printValue = this.props.value ? this.props.value.toString() : '';

    if (this.props.type === 'file') {
      return (
        <div className="file-field input-field">
          <div className="btn">
            <span>{this.props.label} {this.props.required ? '(*)' : ''}</span>
            <input
              type="file"
              onChange={
                (e: ChangeEvent<HTMLInputElement>) => (
                  this.props.onChange(e!.target!.files![0])
                )
              }
              className={this.props.disabled ? 'disabled' : ''}
              maxLength={this.props.maxLength}
            />
          </div>
          <div className="file-path-wrapper">
            <input className="file-path validate" type="text" />
          </div>
        </div>
      );
    }

    if (this.props.type === 'textarea') {
        return (
            <div className="input-component input-field">
                {this.renderIcon()}
                <textarea
                    rows={3}
                    id={this.props.id}
                    value={printValue}
                    placeholder={this.props.placeholder || ''}
                    onChange={(e) => this.props.onChange(e.target.value)}
                    className={'text-area materialize-textarea ' + (this.props.disabled ? 'disabled' : '')}
                    maxLength={this.props.maxLength}
                />
                <label
                    htmlFor={this.props.id}
                    className={this.props.value ? 'active' : ''}
                >
                    {this.props.label} {this.props.required ? '(*)' : ''}
                </label>
            </div>
        );
    }

    return (
      <div className="input-field">
        {this.renderIcon()}
        <input
          autoComplete={this.props.autocomplete ? 'on' : 'off'}
          id={this.props.id}
          type={this.props.type}
          value={printValue}
          required={true}
          placeholder={this.props.placeholder}
          onChange={(e) => {
            this.props.onChange(e.target.value);
          }}
          onBlur={this.props.onBlur}
          className={this.props.disabled ? 'disabled' : ''}
        />
        <label
          htmlFor={this.props.id}
          className={this.props.value ? 'active' : ''}
        >
          {this.props.label} {this.props.required ? '(*)' : ''}
        </label>
      </div>
    );
  }

  private renderIcon(): React.ReactNode {
    if (!this.props.iconName) {
      return;
    }

    return (
      <i className={this.props.value ? 'material-icons prefix active' : 'material-icons prefix'}>
        {this.props.iconName}
      </i>
    );
  }
}

export default InputComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/input/Input.component.tsx